module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Charlie worked in advertising. It was what he had done for twenty-eight years. In his younger days he was in love with his chosen profession, thinking it inspiring, relevant, and even important. It was not a job, he thought, so much as it was a calling. It demanded his best efforts and he was happy to oblige. He came up on the creative side and spent long hours writing copy and later developing campaigns for mufflers, cookies, bagels, and cars. His work won awards, garnered praise, and for a long time that was enough.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("While Charlie’s love affair with advertising had cooled over the years—the hours, the client demands, and the competitiveness take a toll—he persevered, dutifully making his way up the ladder. Promotions came slowly, then quickly, and on the eve of his forty-ninth birthday Charlie found himself running one of the largest ad agencies in Chicago, an achievement that, at the time, he thought completed him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His sense of satisfaction was tempered by the stress of the job. Heading up any large agency was a serious affair and the stakes were high; a loss of a key account could result in the loss of dozens of jobs, including his own. For the most part, however, Charlie felt he was up to the task, although there were moments he had his doubts.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After Angelo dropped him off, he took the elevator to the fortieth floor and allowed himself a brief stroll. It had been exactly one year since his promotion and he was feeling reflective. Despite mounting pressures, and the fact that business wasn’t good and the economy was terrible, overall he thought he still enjoyed what he did. He certainly was a slave for the trappings of his job—the corner office with panoramic views of Lake Michigan, the overseas travel, the car service, the health club membership, and, of course, the pay. In particular, Charlie liked the agency’s office: the sterile but elegant reception area with the marble floor and spiral staircase that led up to the creative department and down to accounting. He liked the artwork, German contemporary, with rivers and lakes and pastures, muted browns and greens, that lined the walls. And he liked the sense of order and purpose created by the row of cubicles that ran the length of the halls, the lunch area with the Ping-Pong table, the jukebox, the cappuccino bar, the Elvis Presley and James Dean wax figures, and the Idea Room, with its vaulted windows and solid oak circular table that he had personally selected.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Charlie particularly liked the way the office looked in the morning with the faint rays of orange light appearing over Lake Michigan, first a hint, then a burst, everything kissed in warmth and hopeful brightness. A new day dawning. A new day at work.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He had been recruited to the agency four years earlier and then been promoted to executive vice president, general manager, after Bob O’Malley left. Actually, Bob O’Malley died, leaving the company with dwindling revenues, poor morale—and Charlie temporarily in charge. (He was named interim general manager the day of O’Malley’s funeral.) After what Charlie thought was a protracted five-month search, Helmut officially gave him the top job in a two-sentence e-mail: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("We are removing interim from your title. Congratulations.")]), _vm._v(" He printed the e-mail out and had it framed, even though he was disappointed that Helmet hadn’t included an exclamation point after the word congratulations. He would have added the exclamation point. The occasion warranted one.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After he completed his lap around the floor, Charlie entered his own office, and took in the parquet floor, the Persian rug, the matching leather club chairs, the six-foot-tall gumball machine, and finally the framed portrait of Abraham Lincoln. He idolized Lincoln, drew strength from him. They both had had difficult if not impossible tasks: Lincoln’s, to save the Union; Charlie, the Odor Eaters account.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He nodded once deferentially at the picture, and once again regretted his inability to finish one of the many Lincoln biographies he had bought. (Charlie had a short attention span and seldom, if ever, finished a book.) Then he slowly made his way to his desk and sat down. He had no desire to deal with Project Phoenix Rising…his plan for reorganizing the agency. He had been working halfheartedly on it for weeks, and dreaded what it involved. He was going to have to make some drastic changes, including realigning departments and cutting staff. Even though he knew these steps were necessary if the agency had any hope of returning to profitability, Charlie had been dragging his feet on finishing, much less implementing, the plan. He had no stomach for layoffs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Before he plunged into Project Phoenix Rising, he decided to take another quick look at his now-infamous “fat” memo. Over the past year, Charlie had become increasingly concerned with the weight of his staff. He felt the agency employed a high number of obese or borderline obese people. During the last month, on two separate occasions, staffers had shattered chairs in client meetings, falling like loads of bricks onto the floor, scattering papers and files. In addition, a senior vice president who headed the largest account had taken to flying first-class (big seats) whenever she traveled because of her enormous size…a cost the firm had to absorb. In part, Charlie blamed their key clients—a fast-food fried chicken company, an international baker, and a cheese manufacturer, all of whom provided free samples or coupons to the agency on a regular basis. He primarily blamed O’Malley, though, who had made a point of hiring people as fat as, or fatter than, himself at every opportunity.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The “fat” memo (actually it was called Project Shape Up), which he had distributed more than two weeks prior, conveyed his growing concern over everyone’s growing size. Among other things, it encouraged a collective effort to slim down through a series of 5K fun-runs, low-carb lunches, and nutritional seminars in which Charlie was not only willing to participate, but also to organize and underwrite. He knew he was dealing with a sensitive issue, but he also believed that the agency’s fatness was hurting productivity and contributing to rising health insurance costs. Besides, he was sick of sitting in meetings where three out of four people were breathing heavily out of their mouths.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The memo had been poorly received by the staff. Julie, from human resources, reported that Aiesha, Margie, and Patty—longtime administrative assistants (and the fattest of the fat)—were considering legal action, claiming discrimination and harassment. Most everyone was insulted, even the skinny ones, by what they felt was the condescending nature of the memo. Julie thought Charlie should write a retraction and host a fried chicken lunch to make amends. Charlie refused to do either.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the end, he chose to ignore the backlash but dropped the initiative. He would have to pick his battles. He would eventually get back to it, and hopefully address the issue more effectively before one of the floors collapsed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He read the “fat” memo one last time, thinking it had been straightforward and, with the exception of one sentence, which was intended as a joke ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Elevator rides are getting downright dangerous!")]), _vm._v("), tactfully written. He then called up the Project Phoenix Rising document, looked it over, clicked it off, and called up the Summer Outing file.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The agency had been internally debating where to have their annual summer outing. The locations for the past outings had included a baseball park and an upscale horse racetrack. The summer before the agency had hosted a picnic in a North Shore botanical garden and had invited families. This year—his first as head of the company—he was eager to make his mark and wanted to host the event at a local zoo. He thought this was an inspired, fun, and economical choice. Unfortunately, his decision was met with indifference, if not outright resistance, from the Summer Outing Committee, a group of aging, disgruntled administrative assistants who were lobbying for an elaborate dinner at an upscale restaurant with presumably steel-reinforced chairs. The ensuing stalemate had resulted in the passing of summer without an outing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Since he had promised everyone the best summer outing in the history of the agency, he knew he had to take action. Consequently, he drafted a no-nonsense memo to the committee demanding that a date and a zoo (Chicago had two) be selected by the end of the week.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Charlie carefully read over the draft, fiddling with it here and there, adding lines about the agency’s unique culture and the role the summer outing played in fostering it, before clicking back to the Project Phoenix Rising file. After staring at it helplessly, and feeling very much like a turtle on its back, legs hopelessly waving, he opened his Charlie’s Book Club file.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A few months earlier, in an effort to improve morale, Charlie had started an agency book club. He thought this would be a unique way to bring all the departments together and build needed camaraderie. His first book, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Corporate Buddha")]), _vm._v(", had been the wrong choice. No one read it and no one showed up for the discussion. For reasons he no longer remembered, he let Andre, their moronic associate creative director, pick the second book—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rock You!")]), _vm._v("—which Charlie never got around to reading. It was about the life of a female rock band groupie. (Charlie learned, during the book club meeting, that if you took out all the sex scenes, nothing was left but punctuation.) Virtually the entire agency read this book, and was disgusted and outraged. The book discussion turned into a near riot and ended with Aiesha, Margie, and Patty walking out after threatening sexual harassment and legal action.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Charlie had decided to once again choose a book and, after starting with a list of thirty, had narrowed his choices down to either "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beloved,")]), _vm._v(" by Toni Morrison, which had been an Oprah’s Book Club selection, or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Adventures of Huckleberry Finn,")]), _vm._v(" which he thought an equally safe bet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was leaning toward Huck Finn, so he spent a half hour researching the book online, even taking a brief virtual tour of the Mississippi River. He then decided to table his final choice until the next day. He didn’t want to rush his decision; he knew that the future of Charlie’s Book Club hung in the balance. Besides, he had bigger issues to deal with. Heroically resisting the urge to sigh, he returned to the Project Phoenix Rising file.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Analytically speaking, the agency was in deep shit. They were hemorrhaging clients, costs were way out of control, and they had recently begun losing key people to competitors. The first page of the Project Phoenix Rising document included a list of issues (creative, staff, new business) that Helmut had identified as critical to the future of the agency, matters that needed immediate attention. Charlie studied the list, his eyes first burning, then blurring.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Staring at the computer screen, he was suddenly overwhelmed with the task at hand. “Fat” memos, book clubs, and summer outings were clearly not main concerns. Not for the first time, he felt over his head in his position and longed to be back on the creative side of things. He reread the list of critical issues, realized he could easily add another ten to it, then checked his watch. It was five forty-five in the morning. Then he put his head on his desk and closed his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He fell instantly into a dream about Huckleberry Finn. He was short and freckled and was pushing a raft made of logs into a fast-flowing brown river.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Storm a-comin’,” Huck said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Take me with you, Huckleberry,” Charlie said. He glanced over his shoulder. The landscape was rocky and barren. He knew something terrible was out there, though. Something was coming just over the hill.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Take me with you down the river,” Charlie said. The wind was picking up. “I want to leave. I need to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He peered over his shoulder again and this time saw Aiesha, Margie, and Patty trotting down the hill toward him, waving pieces of fried chicken threateningly over their heads.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I have to go now!” Charlie shouted at Huckleberry, but Huck had pushed off from the shore and was already drifting away. He pointed an oar past Charlie, at the approaching, thundering women.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wait! Please!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They’ll swamp the raft,” Huckleberry yelled as he disappeared into a mist Charlie had not seen coming.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Please,” Charlie yelled over and over. “Please.” But Huck was gone and the mist was everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Georgia, Charlie’s assistant, was frantic.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Charlie Baker, you wake up now. You get up!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What? What are you doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She heaved him upright in his chair. “You can’t be doing this!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not doing anything. Can we please ratchet down the emotions?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You sleeping on the job, Charlie! People see you like that, sleeping, what they going to think?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georgia was a short, stout black woman of indeterminate age. She had been Charlie’s assistant at the old agency and had followed him to the new agency after his promotion.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You get in to work too early,” Georgia said. She dusted off his shoulders for some reason with her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What time is it?” Charlie rubbed his face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nine o’clock.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nine o’clock?” This shocked him. He had been asleep for three hours.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Helmut was looking for you. He’s here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What do you mean? What are you talking about?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Helmut was here!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Charlie stopped breathing. “Helmut? Helmut is here, in Chicago? Already? When?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“About one minute ago. About sixty seconds ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What do you mean, here? Where was he?” Charlie’s voice was rising.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georgia’s eyes grew wider. “Here, Charlie. He was right here in your office.” She whispered this last sentence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("office")]), _vm._v("? You mean, here?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He just walked past me and opened the door.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The image of Helmut marching into his office like it was the Sudetenland and watching him sleep was too much for Charlie. He felt one of his arms tingle, a precursor to numbness. “You mean he just came in here? Did he see me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, he was right here, standing right here.” She pointed to the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But did he see me sleeping?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georgia nodded frantically and began wringing her hands. “There was no way he could miss you. He just walked in. I couldn’t stop him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why didn’t you wake me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I tried. I said your name, I said, Charlie, Charlie, you know, to wake you, but you kept right on sleeping. I didn’t want to yell. I didn’t think that would be appropriate.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Charlie clutched his heart, then pounded his desk with a fist. “This is unbelievable. Just. Unbelievable!” He pounded again. “What was his reaction? Did he say anything?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, he just, you know, watched you sleep for a while.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“A while?”")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then he took a picture of you, you know, with his cell phone, and left.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“What?”")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He said that he would call you after you woke up. He told me to tell you to wait here for him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wait here for him.” Charlie felt an unexpected and sudden flash of anger and indignity. He had nothing to hide from Helmut, had nothing to be ashamed of. “Does he know how hard I work? Does he know I get four hours of sleep a night? Does he?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georgia was confused. She continued to wring her hands. “I’m not sure. Well, I don’t know. That didn’t really come up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Does he know that I haven’t had a weekend off in six months, that I haven’t had a vacation since I came to this place? Does he know that…that I’m getting…a mole? Does he know that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A mole?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes. A mole!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You have a mole?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Charlie paused. He wasn’t sure where the mole was. “It’s…it’s migrating. Moving.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You have a mole that moves?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s a…just forget it, I don’t want to get into it now. It’s too serious.” He took another deep breath, and tried to remember if Lincoln, in his years as President, had ever been caught sleeping at his desk, and if so, what his response had been. “Why do you think he took a picture?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t know, Charlie, he said something, I think it was in German, I couldn’t be sure. Plus you were snoring, so I couldn’t hear that well.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Snoring! Jesus!” Charlie grabbed at his heart and took more deep breaths. “Listen, where is he now? Helmut? Just where did he go?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Helmut? He’s down with Mr. Marken.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Marken!” Charlie hissed this name. Marken was the chief financial officer, a rigid man with yellow teeth who was constantly harping over the dwindling revenue and spiraling costs. After O’Malley died, he had been Charlie’s rival for the top spot and had made a point of making his life miserable every one of the past twelve months by plotting and conspiring against him. This was a worst-case scenario.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Georgia, close the door,” he whispered. By this point, Charlie had lost total feeling in his arm.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It is closed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Georgia, I think I’m having a heart attack.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A heart attack?” Georgia’s eyes suddenly encompassed most of her face. She wrung her hands some more. “Oh, my God, Charlie Baker.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can feel it in my arm.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She looked terrified. “Your "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("arm")]), _vm._v(" is having a heart attack?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It starts in your arm and makes its way over.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How much time before it gets to your heart?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Minutes, seconds, Jesus, God, I don’t know!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georgia made a move for the door. “I’m calling an ambulance.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wait! Don’t! Don’t call an ambulance! Do not! I don’t have time to go to the hospital. Please just don’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georgia stared at him and considered the situation. “You want me to sit with you again, Charlie?” She asked this quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He feebly nodded. Georgia pulled up a chair and sat across from his desk.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They didn’t say anything. Charlie looked out the window. “I don’t want to end up like O’Malley,” he said finally.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georgia appeared confused. “What do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It killed him. The job. The stress killed him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georgia was quiet again. “But Mr. O’Malley was struck by lightning.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Charlie continued to rub his arm, then he said, “He was worn down by the stress. If he had been in better shape, if he hadn’t been "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("beaten down")]), _vm._v(", he might have withstood the bolt.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But Angelo said Mr. O’Malley blew up. One of his arms ended up in a tree.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t give a shit what Angelo says, okay? What is he, a doctor? They teach medicine at the limo academy? And for the record, it didn’t end up in a tree, okay? I’m sick of hearing that. That’s a rumor. That’s…that’s myth! Everything was still attached. I saw photos. He was just a little red, that’s all. And bald.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Bald?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, bald. Big deal.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georgia sat back and shook her head. “He didn’t seem stressed. He was always happy, you know, positive-like.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah, well, he was drunk all the time. That’s why he was positive-like. Anyone can be positive-like after a case of Jim Beam.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He didn’t drink that much. Didn’t drink much at all. Besides, a stiff drink won’t hurt you. Loosen you up a little. A drink once in a while can help you deal with things. Make you less tense, you know…less uptight.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Charlie stopped rubbing his arm. “You think I’m uptight? Is that what you’re saying?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georgia shrugged and looked off to the side. “I didn’t say that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You were implying that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I wasn’t implying anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, you were. I know when things are being implied. I’m very good at that. You were implying that I’m uptight.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georgia sighed. “I don’t want to get started with you today, Charlie Baker. I just do not.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is that what everyone is saying about me? Are they saying I’m uptight?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georgia pretended to pick at something on her skirt, before smoothing it with one hand. “I don’t listen to what people say. I’m too busy. I got things to do. I spend all day running around here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Charlie swiveled in his chair and looked back out the window. Michigan Avenue had come to life with buses, cabs, cars, clusters of pedestrians waiting at corners. It was a sunny and warm fall morning. As he stared down at this scene, the world seemed an orderly and rational place.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You know, Charlie, if you don’t want to drink, maybe you should pray once in a while. That’s what I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He looked at Georgia again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Just a little prayer. Can’t hurt, Charlie. That’s the thing about praying, it can never hurt.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Pray.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Just a small one.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georgia’s recommendation to both drink and pray was doing nothing for Charlie’s mood. “Let me ask you something here,” he said. “And I need you to be perfectly honest, perfectly open. Do people hate me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georgia looked uncomfortable. She cleared her throat and looked down at the floor. “Everyone likes you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s very nice of you to say that, but I suspect that’s not true. People hate me here. I can feel it. No one ever talks to me, or says hello to me in the halls.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s not true. People say hello.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah, well, that’s all they say. Listen, what I need to know is who specifically hates me. Who the primary haters are. Who is anti-Charlie? I need names.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georgia looked up. She was thinking hard. “Most people like you some of the time,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was Charlie’s turn to think hard. He tried to repeat what she said, but gave up. “I’m not sure what that means. What do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m just saying that sometimes you’re nice, quiet Charlie, and other times…you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, I don’t know. What—other times I’m not nice and quiet?” He shouted this.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Other times, you know, you’re like, well, you know…crazy. A little.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Crazy? What do you mean, crazy?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Just crazy, you know…excitable-like.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Excitable and crazy are two completely different things. They have completely different definitions. They’re not even close to meaning the same thing. Which is it?” He slammed the top of his desk with his hand. “Crazy or excitable? It’s important that I know this. It’s critical.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, then crazy. You know, one minute you’re nice and calm and thoughtful and smart and say nice, you know, intelligent things, smart things, insightful things, quiet-like. And the next time, you’re running around like, well, like your hair’s on fire.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Like my hair’s on fire.” He thoughtfully repeated this. “Interesting. Very interesting. Is that the perception of the office? Quiet Charlie, Crazy Charlie?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“More like Nice Charlie, Crazy Charlie. You’re never really quiet. I mean, that quiet.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, that’s very interesting,” he said again. “Very interesting.” He worked hard to control himself even though he wanted to scream that he wasn’t crazy, that this goddamn job with all these goddamn fat asses was making him crazy. He swallowed, did some deep breathing, shook his numbing arm. He felt enraged and hopeless. Then he felt impossibly overwhelmed and slumped forward in his chair. “Things aren’t going very good here, are they?” he asked. “Tell me the truth. Things are going to hell, aren’t they?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georgia shrugged again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What am I doing wrong? What do you think it is? Am I a bad guy?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I wouldn’t work with you if you were.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then why does everyone hate me? Why do all those secretaries hate me? Aiesha and Patty and all of them? They practically hiss every time I walk by.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t worry about them. They just miss Mr. O’Malley, that’s all. We all do.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, I’m not him, okay? I’m sorry he blew up or whatever the hell happened to him. I’m sorry I didn’t martyr myself by deciding to play golf in a hurricane. You know, people forget that I was supposed to be part of that foursome. Angelo took my place. I was supposed to be there! "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("In Bermuda!")]), _vm._v(" My flight was canceled! That bolt could have hit me. Me! No one gives a shit about that. No one ever remembers that. All I hear about is O’Malley, O’Malley, O’Malley!” He sat back and shook his head. “You know, it’s hard to do this job when everyone is against you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Everyone isn’t against you, Charlie.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I have no allies here, no support, no friends. Zero, nothing, nada. I’m flying alone here. Alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s not true,” Georgia said. “You have me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Charlie swallowed, then gazed out the window again, focusing on the top of a bus as it inched its way through traffic some forty stories below. Georgia’s comment made him feel like crying.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You just having a bad stretch, that’s all,” Georgia said. “You had them before. Remember when we lost the Nike account? At the old agency?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That was bad.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But you came right back and got the bagel account.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And it was bigger than the Nike account. Twice as big.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Everyone else was giving up, but you kept your head and brought in new business and all those awards you won.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Two Effies. And we almost won at Cannes, for the Bagel Man campaign.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Those commercials were funny. I would see them and I would laugh and tell my kids, that’s my boss’s idea.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Those were funny spots. I came up with that campaign one night by myself in a hotel bar in Pittsburgh.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know. The Westin William Penn. And you worked all night on them.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I did.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And no one could believe you could get President Clinton to do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It was Bob Dole. He was a senator. I don’t even know if he’s still alive.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And we got the business and you saved everyone’s job.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I did.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You did.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They were both quiet. Charlie didn’t feel like crying anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Those were some fun times. We had some fun back then,” Georgia said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They were fun, I guess.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georgia smiled, her face relaxing. “You feeling better now, Charlie?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A little, yes, thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Heart attack gone?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“For now.” He gave a short smile back and stared at his computer. “Well, I’m not going to wait around all day for Helmut. What time is the staff huddle again?” he asked, even though he already knew. The huddle was always ten o’clock on Monday morning.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s canceled.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He squinted with confusion at Georgia. “Canceled? Who canceled it? It’s my meeting.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mr. Marken canceled it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Marken? He can’t cancel it! It’s my meeting. He can’t cancel it. Marken reports to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He sent everyone an e-mail this morning saying it was canceled.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Charlie quickly swung back to his computer and checked his e-mail.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I didn’t get any message.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georgia squirmed in her chair. “Well, maybe he just forgot.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Charlie stood up. “He doesn’t forget anything. Where is he?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Still in his office, I guess. With Helmut.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He sat down again. Then he stood back up. “Well, this is bullshit. What are they doing in there? I mean, just what the hell are they doing?” He pounded the desk for a third time that morning. Georgia stood up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where are you going?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Charlie was standing perfectly still when she asked this. He really hadn’t planned on going anywhere. But he realized then that he had to go see Marken and Helmut. His heart raced.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m going to go see them.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You are?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes.” He moved quickly around the desk and headed for the door. When he placed his hand on the doorknob, he turned one last time to Georgia. “Tell everyone our staff huddle is back to the original time.” He said this authoritatively and in a deep voice.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Georgia, eyes wide, swallowed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When he opened the door, a tall, thin man was standing there. He was wearing an ugly, off-white short-sleeve shirt and a narrow black tie. Charlie had never seen the man before, so he had no way of knowing that he was staring directly into the face of his future.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mr. Baker?” he asked. He had a soft voice tinted with a British accent.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m Ned Meyers.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Charlie stood there looking at him. He assumed he was from the mailroom.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m here to answer any questions you may have and to help you with the transition.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When Charlie didn’t respond, he continued, “I’m from Rogers & Newman.” He said this in a way that assumed some understanding.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who?” The name sounded vaguely familiar.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The man searched Charlie’s face with intense brown eyes, then looked embarrassed, his cheeks splotching red. He quickly checked his watch, mumbled incoherently, and disappeared down the hall in a lope.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Charlie glanced back at Georgia, who was standing silently by his desk, eyes still huge in what looked like fear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who was that?” he asked. But at that moment his phone rang, and she answered it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s Helmut,” she said, her voice just above a whisper. Her face looked resigned. “He’s in Mr. Marken’s office. He wants to see you, Charlie. He wants to see you right now.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21071e42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312365486_ch02.vue
// module id = 69
// module chunks = 0